<!--
signup.vue will be responsible for maintaining and submitting the signup glob which may of come from a db hash entry.
-->
<template>
  <div id="signup-component" :key="apiCallFinished">
    <b-overlay :show="creatingAccount" no-wrap fixed/>
    <form-validator ref="form">
      <div id="signup-group">
        <div>
          <add-services @form-state="val=>servicesValid=val" :serviceTypes="serviceTypes"/>
        </div>
        <div v-if="displayInline"><br><br><hr><br><br></div>

        <div class="container" v-if="servicesValid">
          <hr>
        </div>

        <transition v-on:enter="scrolldown('attribution-dropdown-su')">
          <div v-show="servicesValid && !skipClicked" class="container" id="attribution-dropdown-su">
            <attribution-dropdown @input="setAttributionData" @skip-clicked="skipClicked = true" ref="attribution"/>
            <br/>
          </div>
        </transition>

        <transition v-on:enter="scrolldown('customer-signup-form-su')">
          <div v-show="servicesValid" class="container" id="customer-signup-form-su">
            <customer-signup-form @form-state="val=>customerValid=val" @input="setCustomerData"  ref="customerSignup"/>
          </div>
        </transition>

        <div v-if="displayInline"><br><br><hr><br><br></div>
        <transition v-on:enter="scrolldown('order-summary-payment-method')">
          <div v-show="servicesValid && customerValid" class="container" id="order-summary-payment-method">
            <br/>
            <hr/>
            <order-summary v-if="servicesValid && customerValid"/><br/>
            <payment-method @input="setPaymentData" :init-values="initValues" @form-state="val=>paymentValid=val" ref="addPayment"/>
          </div>
        </transition>
        <div v-if="displayInline"><br><br><hr><br><br></div>
        <transition v-on:enter="scrolldown('user-agreement-submit')">
          <div v-show="servicesValid && customerValid && paymentValid" id="user-agreement-submit">
            <user-agreement @input="setAgreementData" @form-state="val=>agreementValid=val" ref="userAgreement"/>
            <br/>
            <div class="container">
              <div id="create-container" class="text-center">
                <order-button :disabled="!formValid" :title="!formValid ? 'You must check I agree above to continue' : ''" @click="selfSignup"/>
                <small v-if="!formValid" class="d-block">Please check "I agree" first</small>
              </div>
            </div>
          </div>
        </transition>
        <div v-if="showFormData" class="container">
          <br/>
          <h5>Form data</h5>
          <button @click="showForm = !showForm">{{ showForm ? 'Hide' : 'Show' }}</button>
          <pre v-if="showForm">{{ formDataString }}</pre>
        </div>
      </div>
    </form-validator>
  </div>
</template>

<script>

import CustomerSignupForm from "../components/Signup/CustomerSignupForm.vue";
import UserAgreement from "../components/Signup/UserAgreement.vue";
import AddServices from "../components/Signup/AddServices.vue";
import FormValidator from "../components/FormValidator.vue";
import {BOverlay, BImg, BSpinner, BDropdown, BDropdownItemButton, BIconCheck}  from "bootstrap-vue";
import OrderSummary from "../components/Signup/OrderSummary.vue";
import * as types from '../store/mutation-types';
import helpers from '../lib/helpers';
import {mapGetters} from 'vuex';
import logger from "../lib/logger";
import Notifications from "../components/Notifications.vue";
import PaymentMethod from "../components/Signup/PaymentMethod.vue";
import AttributionDropdown from "../components/Signup/AttributionDropdown.vue";
import OrderButton from "../components/Signup/OrderButton.vue";

export default {
  name: "signup",
  components: {
    OrderButton,
    Notifications,
    FormValidator,
    AttributionDropdown,
    CustomerSignupForm,
    AddServices,
    PaymentMethod,
    UserAgreement,
    BOverlay,
    BImg,
    BSpinner,
    BDropdown,
    BDropdownItemButton,
    BIconCheck,
    OrderSummary
},
  created() {
    // add recaptcha script
    const recaptchaScript = document.createElement("script");
    recaptchaScript.setAttribute("src", "https://www.google.com/recaptcha/api.js?render=" + this.recatpchaSiteKey);
    document.head.appendChild(recaptchaScript);

    let self = this
    if (this.signupHash !== undefined) {
      $.ajax({
        type: 'GET',
        tryCount: 0,
        url: `/manage/api/v1.0/self_signup/pre_signup/${this.signupHash}`,
        contentType: 'application/json',
        success(result){
          self.$store.commit(types.SELF_SIGNUP_SET_INIT_VALUES, {signup_hash: self.signupHash, data: result});
        },
        error(jqXHR, textStatus, errorThrown) {
          //reject(jqXHR.responseJSON.title)
        }
      })
    }

    // hard set to light mode for the self signup page
    if (this.hasDarkTheme) {
      this.hadDarktheme = true;
      this.$store.dispatch('setLightTheme', false);
    }
  },

  data (){
    return {
      scrolldown: helpers.scrolldown,
      servicesValid: false,
      skipClicked: false,
      customerValid: false,
      paymentValid: false,
      agreementValid: false,
      // initServices: [],// todo make init data objs computed based off of pre_signup data and emitted addresses
      signupHash: this.$route.query.signupHash,
      displayInline: this.$route.query.displayInline === 'true',
      apiCallFinished: false,
      creatingAccount: false,
      recatpchaSiteKey: '6Le3_GEmAAAAALmjy7zJ1OluUj5NeIBuX_uRNJsM',  //'6LfkZQAhAAAAAK6J_oxs2aQQl-zn2OFy10aurhMU'
      hadDarktheme: false,
      showForm: false
    }
  },

  computed:{
    serviceTypes(){
      let st = this.$route.params.components || this.$route.query.components
      return st? st.split(',') : []
    },
    initValues() {
      let init_values = JSON.parse(JSON.stringify(this.ssuInitDetails));
      logger.debug('initValues', init_values);
      return init_values;
    },
    formValid(){
      return this.servicesValid && this.customerValid && this.paymentValid && this.agreementValid
    },
    formData() {
      return this.ssuOutputModel;
    },
    formDataString () {
      return JSON.stringify(this.formData, null, 2);
    },
    showFormData(){
      logger.debug('showFormData', process.env.NODE_ENV, this.$route.query.showFormData)
      if (process.env.NODE_ENV !== 'development') {
        return false;
      }
      if (!this.$route.query.showFormData) {
        return false;
      }
      return this.$route.query.showFormData.toLowerCase() === 'true';
    },
    ...mapGetters([
      'hasDarkTheme',
      'ssuInitDetails',
      'ssuOutputModel',
      'ssuLoginDetails'
    ]),
  },
  methods: {
    setAttributionData (attribution) {
      logger.debug('set attribution data', attribution)
      this.$store.commit(types.SELF_SIGNUP_SET_ATTRIBUTION_DATA, attribution);
    },
    setCustomerData(customer) {
      // logger.debug('set customer data', customer)
      this.$store.commit(types.SELF_SIGNUP_SET_CUSTOMER_DATA, customer);
    },
    setPaymentData(payment) {
      // payment data is already from the store, so we copy it to avoid incorrect mutation errors
      logger.debug('set payment data', payment)
      this.$store.commit(types.SELF_SIGNUP_SET_PAYMENT_DATA, JSON.parse(JSON.stringify(payment)));
    },
    setAgreementData(agreement) {
      this.$store.commit(types.SELF_SIGNUP_SET_AGREEMENT_DATA, agreement);
    },
    selfSignup(){
      this.creatingAccount = true
      this.$store.commit(types.HIDE_ALL_NOTIFICATIONS)
      let self = this
      let data = this.formData;
      let alert_payload = {'type': 'error', 'message': "We\'re having difficulty processing your request. Please try again, or contact XMission Customer Service at (801) 539-0852 or sales@xmission.com"};
      try {
        grecaptcha.ready( () => {
          grecaptcha.execute(self.recatpchaSiteKey, {action: 'submit'}).then((token) => {
            data['recaptcha_token'] = token;
            $.ajax({
              type: 'POST',
              tryCount: 0,
              url: '/manage/api/v1.0/self_signup',
              contentType: 'application/json',
              data: JSON.stringify(data),
              success(result){self.selfSignupSuccess(result)},
              error(jqXHR, textStatus, errorThrown){self.selfSignupError(jqXHR, textStatus, errorThrown)},
              complete(){setTimeout(()=>{self.creatingAccount = false}, 30000)}
            })
          }).catch((e) => {
            logger.error('Error checking recaptcha', e);
            self.$store.commit(types.ADD_NOTIFICATION, alert_payload);
            self.creatingAccount = false;
          })
        });
      } catch (e) {
        logger.error('Error readying recaptcha', e);
        this.$store.commit(types.ADD_NOTIFICATION, alert_payload);
        this.creatingAccount = false;
      }
    },
    selfSignupSuccess(result){
      //logger.log('signup success is ', result)
      this.firstLogin()
    },
    selfSignupError(jqXHR, textStatus, errorThrown){
      // logger.log('signup error', jqXHR, textStatus, errorThrown)
      let response = jqXHR.responseJSON
      this.$store.commit(types.ADD_NOTIFICATION, {'type': 'error', 'message': response.msg})
      if (response.status < 400){
        this.firstLogin()
      } else {
        this.creatingAccount = false
        // unkown/customer error (cant login)
        // update pre_signup with error status and data ?
      }
    },
    firstLogin(){
      if (this.hadDarktheme) {
        this.$store.dispatch('setDarkTheme', false);
      }
      let self = this
      setTimeout(function() {
        self.$store.dispatch('login', {
          username: self.ssuLoginDetails.uid,
          password: self.ssuLoginDetails.password,
          keepNotifications: true,
        }).then(() => {
          self.$store.commit(types.ADD_NOTIFICATION, {'type': 'success', 'message': 'You have succeeded in creating an account and signing up for services with XMission. You\'ll receive an email with more details soon.'})
          self.creatingAccount = false
          self.$router.push({name: 'account'})
          // force scroll to top of page
          document.body.scrollTop = document.documentElement.scrollTop = 0
        }, (errorMessage) => {
          self.$store.commit(types.ADD_NOTIFICATION, {'type': 'error', 'message': 'Automatic login failed. Please login manually.'})
          self.creatingAccount = false
          self.$router.push({name: 'login'})
        })
      }, 4000)
    }
  }
}
</script>

<style scoped>
#signup-component {
  background:white;
  color:#212529;
  min-height:100vh;
  padding-bottom: 60px;
}
#signup-component >>> input, #signup-component >>> input:focus, #signup-component >>> select, #signup-component >>> .dropdown-menu, #signup-component >>> .dropdown-item {background:#f0f1f2; color:#495057; }
#signup-component >>> .btn-secondary {background:#c5c8c9; color:#495057;}
#signup-component >>> .dropdown-item:hover {background:#c5c8c9; color:#495057;}
#signup-component >>> table {color:#212529;}
#signup-component >>> hr {border-top: 1px solid rgba(0,0,0,0.1);}
#signup-component >>> .order-btn-active {background:#007bff; color:#ffffff;}

</style>




// WEBPACK FOOTER //
// Signup.vue?49b3615a